if (!customElements.get("quantity-input")) {
  customElements.define(
    "quantity-input",
    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });

        this.querySelectorAll("button").forEach((button) => {
          // Prevent multiple event listeners
          if (!button.hasAttribute("data-quantity-handled")) {
            button.setAttribute("data-quantity-handled", "true");
            button.addEventListener("click", this.onButtonClick.bind(this));
          }
        });
      }

      onButtonClick(event) {
        event.stopImmediatePropagation();
        event.preventDefault();

        if (this.input) {
          const previousValue = this.input.value;
          const incrementValue =
            parseInt(this.input.getAttribute("data-increment-value")) || 1;
          const currentValue = parseInt(this.input.value) || 1;
          const minValue = parseInt(this.input.min) || 1;
          const maxValue = parseInt(this.input.max) || 999;

          if (event.currentTarget.name === "plus") {
            const newValue = Math.min(maxValue, currentValue + incrementValue);
            this.input.value = newValue;
          } else if (event.currentTarget.name === "minus") {
            const newValue = Math.max(minValue, currentValue - incrementValue);
            this.input.value = newValue;
          }

          if (previousValue !== this.input.value)
            this.input.dispatchEvent(this.changeEvent);
        }
      }
    }
  );
}
